<div class="filter-title filter-label table-checkbox-group" [class.disabled]="!isActive">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!isActive" [disabled]="disabledWhen" (click)="toggle()"></button>
  </span>
  <div class="table-checkbox-label">
    @if (labelText) {
      <span class="filter-title-text">{{ labelText }}</span>
    } @else {
      <ng-content></ng-content>
    }

    @if (equipmentType) {
      <app-equipment-tier-picker
        [equipmentType]="equipmentType"
        [active]="isActive"
        [exampleName]="exampleName!"
        [rarity]="rarity"
        [fractured]="fractured"
        [veiled]="veiled"
        [memoryStrands]="memoryStrands"
        [isWaystone]="isWaystone"
        [alignLeft]="alignLeft ?? false"
        [disabled]="disabled ?? false"
        [influence]="influence"
        [sockets]="sockets"
        [isCurrency]="isCurrency"
        [isPoe1Gem]="isPoe1Gem"
        [defaultVisible]="defaultVisible"
        [defaultHidden]="defaultHidden"
        [standalone]="standalone ?? false"></app-equipment-tier-picker>
    }
  </div>
</div>

